import React, { useState } from "react";
import UnitSystemSection from "./UnitSystemSection";
import UnitDimensionSection from "./UnitDimensionSection";
import UnitSection from "./UnitSection";

type SubPanel = "systems" | "dimensions" | "units";

interface Props {
    token: string;
}

const UnitsPanel: React.FC<Props> = ({ token }) => {
    const [active, setActive] = useState<SubPanel>("systems");

    return (
        <div className="units-panel">
            <h2 style={{ marginBottom: "1.5rem" }}>Units Management</h2>

            <div className="mode-toggle" style={{ marginBottom: "1.5rem" }}>
                <button
                    onClick={() => setActive("systems")}
                    className={active === "systems" ? "active" : ""}
                >
                    Unit Systems
                </button>
                <button
                    onClick={() => setActive("dimensions")}
                    className={active === "dimensions" ? "active" : ""}
                >
                    Unit Dimensions
                </button>
                <button
                    onClick={() => setActive("units")}
                    className={active === "units" ? "active" : ""}
                >
                    Units
                </button>
            </div>

            {active === "systems" && <UnitSystemSection token={token} />}
            {active === "dimensions" && <UnitDimensionSection token={token} />}
            {active === "units" && <UnitSection token={token} />}
        </div>
    );
};

export default UnitsPanel;
